"use client"

import * as React from "react"
import { EyeOff } from "lucide-react"
import { Button } from "@/components/ui/button" // shadcn/uiのボタンなど
import { useHideContext } from "./HideContext"

/**
 * ページ内のすべての <Hide> を「隠す」状態に戻すボタン
 */
export function HideResetButton() {
  const { resetAll } = useHideContext()

  const handleReset = () => {
    resetAll()
  }

  return (
    <div className="mt-6 text-center">
      <Button variant="outline" size="sm" onClick={handleReset}>
        <EyeOff className="w-4 h-4 mr-2" />
        すべて伏せ字に戻す
      </Button>
    </div>
  )
}
